import React, { Component } from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import FormControl from 'react-bootstrap/lib/FormControl';
import Alert from 'react-bootstrap/lib/Alert';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormGroup from '../inputs/fg-input.js';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import Button from 'react-bootstrap/lib/Button';
import { FormattedMessage } from 'react-intl';
import StaffTypeSelector from '../inputs/staff-types-selector.js';
import TranslationService from '../../services/translation-service.js';
import BulkImport from './teacher-bulk-import.js';
import Select from 'react-select';
import ClassSelector from '../inputs/classes-selector.js';

export default class TranslationEdit extends React.Component {

    constructor(props) {
        super();
        this.state = { translation: undefined, submit: props.submit || function () { }, table: props.table };

    }

    onSelect(selectedClasses) {
        this.setState({ selectedClasses: selectedClasses })
    }

    componentWillReceiveProps(nextProps) {
        this.props = nextProps;
        this.setState({
            translation: this.props.translation,
            newTranslation: this.props.translation
        })

        if (this.state.set === true) return;
    }

    submit() {

        console.log(this.state.translation);

        if (this.state.newTranslation.text != undefined) {
            var newTranslation = this.state.newTranslation.text;
        } else {
            var newTranslation = this.state.newTranslation;
        }

        if (this.state.translation.language_uid != undefined) {
            var uid = this.state.translation.uid + ',' + this.state.translation.language_uid;
        } else {
            var uid = this.state.translation.vocab_uid + ',' + this.state.translation.to_ietf;
        }

        if (this.state.table.value == undefined) {
            var table = this.state.table
        } else {
            var table = this.state.table.value;
        }

   

        TranslationService.submitUpdate(table, uid, this.state.translation.text, newTranslation, this.state.newPic, this.state.newAudio);

        this.state.submit();
    }

    handleChange(tag, obj) {
        if (tag == "trans") {
            this.setState({ newTranslation: obj.target.value });
        } else if (tag == "pic") {
            this.setState({ newPic: obj.target.value });
        } else if (tag == "audio") {
            this.setState({ newAudio: obj.target.value });
        }
    }

    render() {

        let submitButton = React.createElement(Button, {
            onClick: this.submit.bind(this),
            bsStyle: 'primary',
            className: "btn-block"
        }, <FormattedMessage id="ui-254" defaultMessage="Submit" />);

        var pic = "";
        var audio = "";
        var hasPic = false;
        if (this.state.translation != undefined) {
            var translation = this.state.translation.text;
            if (this.state.translation.picture != undefined) {
                pic = this.state.translation.picture;
                hasPic = true;
            }
            if (this.state.translation.audio != undefined) {
                audio = this.state.translation.audio;
            }
        } else {
            var translation = "";
        }

        if (this.state.newTranslation != undefined) {
            if (this.state.newTranslation.text != undefined) {
                var newTranslation = this.state.newTranslation.text;
            } else {
                var newTranslation = this.state.newTranslation;
            }

        } else {
            var newTranslation = "";
        }

        var newPic = "";
        var newAudio = "";
        if (this.state.newPic != undefined) {
            newPic = this.state.newPic;
        }
        if (this.state.newAudio != undefined) {
            newAudio = this.state.newAudio;
        }

        if (hasPic) {


            return (<Row className="p-l-10 , p-r-10">
                <Row>
                    <Col sm={6}>
                        <FormGroup controlId="formBasicText" >
                            <ControlLabel className="fg-label">{translation}</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup controlId="formBasicText" >
                            <FormControl value={newTranslation} type="text" onChange={this.handleChange.bind(this, "trans")} />

                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col sm={6}>
                        <FormGroup controlId="formBasicText" >
                            <ControlLabel className="fg-label">{pic}</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup controlId="formBasicText" >
                            <FormControl value={newPic} type="text" onChange={this.handleChange.bind(this, "pic")} />

                        </FormGroup>
                    </Col>


                    <Row>
                        <Col sm={6}>
                            <FormGroup controlId="formBasicText" >
                                <ControlLabel className="fg-label">{audio}</ControlLabel>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup controlId="formBasicText" >
                                <FormControl value={newAudio} type="text" onChange={this.handleChange.bind(this, "audio")} />

                            </FormGroup>
                        </Col>
                    </Row>

                </Row>

                <Row>
                    <Col sm={12}>

                    </Col>
                </Row>
                <Row>
                    <Col sm={8}>
                    </Col>
                    <Col sm={4}>{submitButton}</Col>
                </Row>
            </Row>)
        } else {
            return <Row className="p-l-10 , p-r-10">
                <Row>
                    <Col sm={6}>
                        <FormGroup controlId="formBasicText" >
                            <ControlLabel className="fg-label">{translation}</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup controlId="formBasicText" >
                            <FormControl value={newTranslation} type="text" onChange={this.handleChange.bind(this, "trans")} />

                        </FormGroup>
                    </Col>
                </Row>




                <Row>
                    <Col sm={12}>

                    </Col>
                </Row>
                <Row>
                    <Col sm={8}>
                    </Col>
                    <Col sm={4}>{submitButton}</Col>
                </Row>
            </Row>
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/forms/translation-edit.js